export interface BuildSubjectsPreviewResult {
  visibleText: string;
  hiddenCount: number;
}

export const buildEllipsisPreview = ({
  inputStrings,
  previewMaxChars,
  minVisiblePrefixChars,
}: {
  inputStrings: string[];
  previewMaxChars: number;
  minVisiblePrefixChars: number;
}): BuildSubjectsPreviewResult => {
  let usedChars = 0;
  let visibleCount = 0;

  for (const item of inputStrings) {
    const nextLength = item.length + (visibleCount > 0 ? 2 : 0);
    if (usedChars + nextLength > previewMaxChars) {
      break;
    }
    usedChars += nextLength;
    visibleCount += 1;
  }

  if (visibleCount === 0) {
    visibleCount = 1;
  }

  const fullText = inputStrings.join(', ');
  const shouldForceTruncate =
    visibleCount === inputStrings.length && fullText.length > previewMaxChars;
  const finalVisibleCount = shouldForceTruncate ? Math.max(visibleCount - 1, 0) : visibleCount;
  const hiddenCount = Math.max(inputStrings.length - finalVisibleCount, 0);

  let visibleText = inputStrings.slice(0, finalVisibleCount).join(', ');

  if (!visibleText && hiddenCount > 0 && inputStrings[0]) {
    visibleText = inputStrings[0].slice(0, minVisiblePrefixChars);
  }

  return { visibleText, hiddenCount };
};
